namespace TabAurous.Retail {
    export interface GiftVoucherAllocateForm {
        TransDate: Serenity.DateEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        VoucherNo: Serenity.StringEditor;
        CompanyId: Serenity.LookupEditor;
        EmployeeId: Serenity.LookupEditor;
        UserId: Serenity.LookupEditor;
        ItemDetails: GiftVoucherAllocateDetailsEditor;
    }

    export class GiftVoucherAllocateForm extends Serenity.PrefixedContext {
        static formKey = 'Retail.GiftVoucherAllocate';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!GiftVoucherAllocateForm.init)  {
                GiftVoucherAllocateForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.StringEditor;
                var w3 = s.LookupEditor;
                var w4 = GiftVoucherAllocateDetailsEditor;

                Q.initFormType(GiftVoucherAllocateForm, [
                    'TransDate', w0,
                    'VoucherTypeId', w1,
                    'VoucherNo', w2,
                    'CompanyId', w3,
                    'EmployeeId', w3,
                    'UserId', w3,
                    'ItemDetails', w4
                ]);
            }
        }
    }
}
